export type LogLevel = 'debug' | 'info' | 'warn' | 'error';

export interface LogContext {
  correlationId?: string;
  scene?: string;
  unit?: string;
  [key: string]: unknown;
}

export interface LogEntry {
  level: LogLevel;
  msg: string;
  ctx: LogContext | undefined;
  errStack?: string | undefined;
  ts: number;
}

export type LogSink = (entry: LogEntry) => void;

export interface LoggerConfig {
  level: LogLevel;
  sink: LogSink;
}

export interface Logger {
  debug(msg: string, ctx?: LogContext): void;
  info(msg: string, ctx?: LogContext): void;
  warn(msg: string, ctx?: LogContext): void;
  error(msg: string, err?: Error, ctx?: LogContext): void;
}

export const LEVEL_PRIORITY: Readonly<Record<LogLevel, number>> = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
};

export const consoleSink: LogSink = (e) => {
  const fn =
    e.level === 'debug'
      ? console.debug
      : e.level === 'info'
        ? console.info
        : e.level === 'warn'
          ? console.warn
          : console.error;
  fn(`[${new Date(e.ts).toISOString()}] [${e.level}] ${e.msg}`, e.ctx ?? {}, e.errStack ?? '');
};

export const noopSink: LogSink = () => {
  /* silencioso */
};
